module.exports = __webpack_public_path__ + "static/media/cookies.25908c54.svg";